/*******************************************************************************
 * @ngdoc    object
 * @name     Fundraiser
 * @module   csm.books.InitialSetup.services.Data.books
 * @constructor
 * @param {object=} info  Fundraiser info read from database.
 * @description
 * Fundraiser information.
 *******************************************************************************/
/* @ngInject */ export function fundraiserConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'Data.books.Fundraiser',
    $type: 'csm.booksdb.data.Fundraiser, CSMBooksDBCS',
    inherits: 'Data.books.ClassInfo',
    prototype: {
      clubID: null, // Club ID
      clubName: null, // Club name
      notes: null, // Notes
      startDate: null, // Start date.
      endDate: null, // End date.
      createdOn: null // Creation date.
    },
    constructor: function (Data, SERVER) {
      return function (data) {
        Data.books.ClassInfo.call(
          this,
          Object.assign({}, data, {
            type: SERVER.BooksDBConstants.CT_FUNDRAISER
          })
        );
      };
    }
  });
};
